import { Alert, Group, ScrollArea, Stack, Title } from "@mantine/core";
import { IconClock, IconInfoCircle } from "@tabler/icons-react";
import type { TimelineEvent } from "../../types/encounter-drg";
import TimelineItemRow from "./TimelineItemRow";
import { TW } from "./theme";

const TimelinePanel = ({
  events,
  caseCreatedByEmail,
}: {
  events: TimelineEvent[];
  caseCreatedByEmail?: string | null;
}) => {
  return (
    <Stack gap={0} style={{ height: "100%", flex: 1 }}>
      <Group gap="xs" mb="xs">
        <IconClock size={18} color={TW.gray700} />
        <Title order={4} c={TW.gray700}>
          Timeline
        </Title>
      </Group>

      {events.length > 0 ? (
        <ScrollArea.Autosize mah="100%" style={{ flex: 1 }}>
          <div>
            {events.map((event, index) => (
              <TimelineItemRow
                key={event.id}
                event={event}
                isLast={index === events.length - 1}
                caseCreatedByEmail={caseCreatedByEmail}
              />
            ))}
          </div>
        </ScrollArea.Autosize>
      ) : (
        <Alert icon={<IconInfoCircle size={16} />} color="gray" variant="light">
          No timeline events available.
        </Alert>
      )}
    </Stack>
  );
};

export default TimelinePanel;
